
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","d":"M18.793 9.22L6.273 2.1a.745.745 0 00-.38-.1.692.692 0 00-.371.1l-.12.07A.769.769 0 005 2.82v14.34a.502.502 0 00.873.34l3.07-3.38 4.293 7.41a.771.771 0 00.46.35l.332.12h.19a.752.752 0 00.382-.1l3.44-2a.75.75 0 00.351-.45l.1-.37a.742.742 0 00-.07-.57l-4.293-7.41 4.474-1a.49.49 0 00.191-.88z"}})])
          )
        }
      }
    